'use strict';

angular.module('shiftTraderApp')
    .controller('AvailabilityManagementAnalysisCtrl', function($scope, AvailabilityRules, TimeService,
                                                       $state, $stateParams, $location,
                                                       SAErrorHandler, me, org, allDepartments, allPositions,
                                                       Session, allMedUsers, organization_availability_sets,
                                                       AvailabilitySets, AvailabilityChangeRequests,
                                                       UserAvailabilityChangeRequests, PositioningService,
                                                       MWPCompositeAvailabilityService) {
    $scope.me = me;
    $scope.org = org;
    $scope.organization_availability_sets = organization_availability_sets;

    $scope.positions = allPositions;
    $scope.allDepartments = allDepartments;

    if (lodash.some($scope.positions, function(pos) { return lodash.isUndefined(pos.department_id) || lodash.isNull(pos.department_id)})) {
      if (lodash.findIndex($scope.allDepartments, { id: null }) < 0) {
        $scope.allDepartments.push({
          id: null,
          name: 'Uncategorized',
          active: true,
          positions: _.filter($scope.positions, { department_id: null })
        });
      }
    }

    $scope.allDepartments = lodash.map(allDepartments, function(dept) {
      dept._selected = true;
      return dept;
    });

    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      showWeeks: false
    };

    $scope.positions.unshift({id: -1, name: 'All Positions'});

    $scope.state = {
      selectedDepartments: _.cloneDeep($scope.allDepartments),
      nowDate: TimeService.getNowInStoreTime(),
      dayDisplayIndex: 0,
      currentPositionId: -1,
      currentDatepickerOpened: false
    };

    $scope.openCurrentDatepicker = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.state.currentDatepickerOpened === true) {
        $scope.state.currentDatepickerOpened = false;
      } else {
        $scope.state.currentDatepickerOpened = true;
      }
    };


    if (!_.isNull(Session.getAvailabilityAnalysisDate()) && !_.isUndefined(Session.getAvailabilityAnalysisDate())) {
      $scope.state.currentDate = TimeService.getBeginningOfDayFromDate(moment(Session.getAvailabilityAnalysisDate()));
    } else {
      $scope.state.currentDate = TimeService.getBeginningOfDayFromDate($scope.state.nowDate);
    }

    $scope.state.dayDisplayIndex = $scope.state.currentDate.day();
    $scope.state.currentDatepickerDate = TimeService.getBeginningOfDayFromDate($scope.state.currentDate).toDate();


    $scope.$watch('state.currentDatepickerDate', function(newVal, oldVal) {
      if (newVal !== oldVal) {
        $scope.state.currentDate = TimeService.getBeginningOfDayFromDate($scope.state.currentDatepickerDate);
        $scope.state.dayDisplayIndex = $scope.state.currentDate.day();
        Session.setAvailabilityAnalysisDate($scope.state.currentDate.format('YYYY-MM-DD'));

        getCurrentUsersList();

        var fn = function() {
          calcAvailabilityRules();
          findAllRuleIntervals();
          setCurrentOrgStatData();
        };

        if ($scope.state.currentDate.isBefore($scope.state.nowDate)) {
          // if we're going into the past, go get old availability!
          MWPCompositeAvailabilityService.getCompositeAvailability(moment($scope.state.currentDate).subtract(1, 'days'), moment($scope.state.currentDate).add(2, 'days'))
            .then(function(compositeAvailabilityData) {
              // merge availSets into
              _.each(compositeAvailabilityData.availability_sets, function(availSet) {
                var idx = _.findIndex($scope.organization_availability_sets, {id: availSet.id});

                if (idx > -1) {
                  $scope.organization_availability_sets[idx] = availSet;
                } else {
                  $scope.organization_availability_sets.push(availSet);
                }
              });
              fn();
            })
        } else {
          fn();
        }
      }
    });

    $scope.toggleDepartmentSelection = function(idx) {
      $scope.allDepartments[idx]._selected = !$scope.allDepartments[idx]._selected;
      if (!$scope.allDepartments[idx]._selected) {
        var idy = _.findIndex($scope.state.selectedDepartments, {id: $scope.allDepartments[idx].id});
        $scope.state.selectedDepartments.splice(idy, 1);
      } else {
        $scope.state.selectedDepartments.push($scope.allDepartments[idx]);
      }
      getCurrentUsersList();
      findAllRuleIntervals();
      setCurrentOrgStatData();
      $scope.$broadcast('analyticsDataChanged');
    };

    $scope.$watch('state.currentPositionId', function() {
      getCurrentUsersList();
      findAllRuleIntervals();
      setCurrentOrgStatData();
      $scope.$broadcast('analyticsDataChanged');
    });

    $scope.clearPositionFilter = function() {
      $scope.state.currentPositionId = -1;
    };

    $scope.allMedUsers = _.sortBy(_.where(allMedUsers, function(u) {
      return u.$curMemb().active === 1;
    }), 'first_name');

    $scope.changeDayOfWeek = function(dayIndex) {
      $scope.state.dayDisplayIndex = dayIndex;
      findAllRuleIntervals();
      setCurrentOrgStatData();
      $scope.$broadcast('analyticsDataChanged');
    };

    //_.each($scope.allMedUsers, function(u) {
    //  u.$getStatistic('position_distribution', {intervalIdent: 'i1', organization_id: $scope.org.id })
    //    .then(function(response) {
    //      u.statData = response.data;
    //    }, function() {
    //      console.log('failed to load');
    //    });
    //});


    $scope.toggleInReview = function(u) {
      var idx = _.findIndex($scope.allMedUsers, {id: u.id});

      if (idx > -1) {
        u._isShowingApprovedAvailabilitySet = !u._isShowingApprovedAvailabilitySet;
        calcAvailabilityRules();
        findAllRuleIntervals();
        setCurrentOrgStatData();
      }
    };

    var calcAvailabilityRules = function() {
      $scope.availabilityRulesByDay = [[],[],[],[],[],[],[]];
      var theTimeToCheck = moment($scope.state.currentDate).hour(6);

      $scope.availabilityRulesByDay = _.map($scope.availabilityRulesByDay, function(dayArray, dayIndex) {
        return _($scope.organization_availability_sets).where(function(availSet) {
          return availSet.$isApproved() && availSet.$isInEffect(theTimeToCheck);
        }).map(function(availSet) {
          return _.where(availSet.availability_rules, function(rule) {
            return rule.active && rule.day_of_week === dayIndex;
          });
        }).flatten().value();
      });

      // assign availability_sets to the medUsers objects
      _.each($scope.allMedUsers, function(u) {
        u._availabilitySets = _.where($scope.organization_availability_sets, {user_id: u.id});
        u._inReviewAvailabilitySet = _.find(u._availabilitySets, function(availSet) { return availSet.$isInReview()});
        u._currentAvailabilityRules = [];
        u._inReviewAvailabilityRules = [];

        if (_.isUndefined(u._isShowingApprovedAvailabilitySet)) {
          u._isShowingApprovedAvailabilitySet = true; // tells the view that this is currently the approved set
        }


        u._currentAvailabilitySets = _.where(u._availabilitySets, function(availSet) {
          return availSet.$isInEffect(theTimeToCheck) && ( u._isShowingApprovedAvailabilitySet ? availSet.$isApproved() : availSet.$isInReview());
        });

        if (u._currentAvailabilitySets.length > 0) {
          u._lastSubmittedMmnt = _.last(u._currentAvailabilitySets).created_at;
          u._currentAvailabilitySet = _.last(u._currentAvailabilitySets);
        } else {
          u._lastSubmittedMmnt = null;
        }

        u._hasCurrentAvailabilitySet = u._currentAvailabilitySets.length > 0;

        u._currentAvailabilityRules = _(u._currentAvailabilitySets)
          .map(function(availSet) {
            return _.where(availSet.availability_rules, function(rule) {
              return rule.active && rule._type === 'weekly' && rule.day_of_week === theTimeToCheck.day();
            });
          })
          .flatten()
          .value();


        u._preferredHours = _(u._currentAvailabilityRules)
          .where({avail: true})
          .reduce(function(sum, rule) {
            return sum + rule.range_twix.length('minutes') / 60.0;
          }, 0);
        u._unavailableHours = _(u._currentAvailabilityRules)
          .where({avail: false})
          .reduce(function(sum, rule) {
            return sum + rule.range_twix.length('minutes') / 60.0;
          }, 0);
      });
    };

    $scope.groupByDept = function(pos) {
      var idx = _.findIndex($scope.allDepartments, {id: pos.department_id});

      if (idx > -1) {
        return $scope.allDepartments[idx].name;
      } else {
        return '';
      }
    };

    $scope.availabilityChangeRequests = AvailabilityChangeRequests.getAll({organization_id: org.id});

    var getCurrentUsersList = function() {
      $scope.currentUsersList = _.where($scope.allMedUsers, function(u) {
        var factors = [];
        if ($scope.state.currentPositionId > -1) {
          factors.push(_.any(u.users_positions, function(up) {
            var pos = _.find($scope.positions, {id: $scope.state.currentPositionId});
            return up.active && up.position_id === pos.id;
          }));
        }

        var departmentIdsToShow = _.pluck($scope.state.selectedDepartments, 'id');
        var hasDeptMetadata = u.metadata && u.metadata.department_ids_by_org &&
          u.metadata.department_ids_by_org.data && u.metadata.department_ids_by_org.data[org.id];

        factors.push(!hasDeptMetadata || _.any(departmentIdsToShow, function(idToShow) {
            return _.contains(u.metadata.department_ids_by_org.data[org.id], idToShow);
          }));
        return factors.length === 0 || _.all(factors);
      });

      $scope.currentUsersListWithSets = _.where($scope.currentUsersList, function(u) {
        return u._availabilitySets.length > 0;
      });

      $scope.currentUsersListWithoutSets = _.where($scope.currentUsersList, function(u) {
        return u._availabilitySets.length === 0;
      });
    };


    $scope.org.$getStatistic('work_hour_distribution',
      {
        intervalIdent: 'i1',
        organization_id: $scope.org.id,
        type: 'weekday'
      }
    )
      .then(function(response) {
        $scope.orgStatData = response.data;
        setCurrentOrgStatData();
      });

    var setCurrentOrgStatData = function() {
      if ($scope.orgStatData && $scope.orgStatData.data && $scope.orgStatData.data[0]) {
        if ($scope.state.currentPositionId > 0 &&
          $scope.orgStatData.data[0].byPosition &&
          $scope.orgStatData.data[0].byPosition[$scope.state.dayDisplayIndex] &&
          $scope.orgStatData.data[0].byPosition[$scope.state.dayDisplayIndex].stats &&
          $scope.orgStatData.data[0].byPosition[$scope.state.dayDisplayIndex].stats[$scope.state.currentPositionId]) {
          $scope.currentStatData = $scope.orgStatData.data[0].byPosition[$scope.state.dayDisplayIndex].stats[$scope.state.currentPositionId];
        } else if ($scope.orgStatData.data[0].total && $scope.orgStatData.data[0].total[$scope.state.dayDisplayIndex]){
          $scope.currentStatData = $scope.orgStatData.data[0].total[$scope.state.dayDisplayIndex];
        }
        $scope.$broadcast('org:analyticsDataChanged:redraw');
      }
    };



    var positionEndpointCalc = function(ruleCollection, viewTwix, viewTwixLength) {
      return _.sortBy(_.unique(_.flatten([0, viewTwixLength, _.map(ruleCollection, function(rule) {
        //console.log(rule, rule.start_time_minutes, rule.end_time_minutes, rule.range_twix.format());
        var temp;
        var res = [];
        //console.log(viewTwix.format(), viewTwixLength, rule.range_twix.format());
//            console.log(viewTwixLength);
//            console.log(viewTwix.start.twix(rule.start).format());
//            console.log(viewTwix.start.format());
//            console.log(rule.start.format());
//            console.log(viewTwix.start.isDST(), viewTwix.end.isDST());


        temp = viewTwix.start.twix(rule.start).length('minutes');
        //console.log(temp, viewTwix.start.twix(rule.start).format(), viewTwix.start.format(), rule.start.format());

        if (viewTwix.start._offset !== rule.range_twix.start._offset) {
          //console.log(temp, viewTwix.start._offset, rule.range_twix.start._offset);
          temp = temp + (viewTwix.start._offset - rule.range_twix.start._offset);
        }

        res.push(temp > 0 ? _.clone(temp) : 0);
        temp = viewTwix.start.twix(rule.end).length('minutes');
        //console.log(temp, viewTwix.start.twix(rule.end).format(), viewTwix.start.format(), rule.end.format());

        if (viewTwix.start._offset !== rule.range_twix.end._offset) {
          //console.log(temp, viewTwix.start._offset, rule.range_twix.end._offset);
          temp = temp + (viewTwix.start._offset - rule.range_twix.end._offset);
        }

        res.push(temp > viewTwixLength ? viewTwixLength : temp);
        //console.log(res, temp);
        return res;
      })])));
    };

    var positionTestFn = function(dikt, ruleCollection, viewTwix) {
      var testPoint = moment(viewTwix.start).add(dikt.interval[0] + 1, 'minutes');
      dikt.count = _.where(ruleCollection, function(rule) {
        return rule.range_twix.contains(testPoint);
      }).length;
    };



    var positionStyleFn = function(redInt, greenInt, blueInt) {
      return function(dikt, idx, previousDikt, maxCount) {
        if (idx > 0 && dikt.count > 0 && previousDikt.count > 0) {
          dikt.styling['border-left'] = 'none';
        }

        dikt.styling['background-color'] = 'rgba(' + redInt + ',' + greenInt + ',' + blueInt + ',' + (Math.pow(2, 0.92 * (dikt.count / maxCount)) - 0.9) + ')';
        dikt.uniqueId = dikt.styling.left + '-' + dikt.styling.width + '-' + dikt.count;
      };
    };


    var findAllRuleIntervals = function() {
      var currentViewWindow = TimeService.getDayTwixFromDate($scope.state.currentDate);

      var unavailableAvailabilityRules = _.flatten(_.map($scope.currentUsersList, function(u) {
        return _.map(_.where(u._currentAvailabilityRules, function(rule) {
          return !rule.avail;
        }), function(rule) {
          rule.$setStartEnd(currentViewWindow.start);
          return rule;
        });
      }));

      var notUnavailableRules = _($scope.currentUsersList).map(function(u) {
        // process through all of the unavailable rules
        // find the opposing intervals

        var unavailIntervals = [];
        var unavailRules = _.where(u._currentAvailabilityRules, function(r) {
          return r.avail === false;
        });

        var notUnavailableIntervals = [];
        var pointer = 0;

        _.each(unavailRules, function(r) {
          unavailIntervals.push([r.start_time_minutes, r.end_time_minutes]);
        });

        if (unavailIntervals.length > 0) {
          _.each(unavailIntervals, function(interval) {
            if (interval[0] > pointer) {
              notUnavailableIntervals.push([pointer, interval[0]]);
              pointer = interval[1];
            }

            if (interval[1] === 1440) {
              pointer = interval[1];
            }
          });

          if (pointer < 1440) {
            notUnavailableIntervals.push([_.last(unavailIntervals)[1], 1440]);
          }
        } else if (u._hasCurrentAvailabilitySet) {
          notUnavailableIntervals.push([0, 1440]);
        }

        return notUnavailableIntervals;
      }).where(function(arr) { return arr.length > 0})
        .map(function(uIntervals) {
          return _.map(uIntervals, function(interval) {
            var x = AvailabilityRules.initWithData({
              day_of_week: $scope.state.dayDisplayIndex,
              start_time_minutes: interval[0],
              end_time_minutes: interval[1],
              avail: true,
              recurring: true,
              repeats_on_weekly: true
            });
            x.$setStartEnd(currentViewWindow.start);
            return x;
          });
        }).flatten().value();


      var availableAvailabilityRules = _.flatten(_.map($scope.currentUsersList, function(u) {
        return _.map(_.where(u._currentAvailabilityRules, function(rule) {
          return rule.avail;
        }), function(rule) {
          rule.$setStartEnd(currentViewWindow.start);
          return rule;
        });
      }));



      var unavailRuleIntervals = PositioningService.calcWorkIntervals(unavailableAvailabilityRules,
        currentViewWindow,
        positionEndpointCalc, positionTestFn, positionStyleFn(152, 52, 52));

      var notUnavailRuleIntervals = PositioningService.calcWorkIntervals(notUnavailableRules,
        currentViewWindow,
        positionEndpointCalc, positionTestFn, positionStyleFn(148, 150, 101));

      var availRuleIntervals = PositioningService.calcWorkIntervals(availableAvailabilityRules,
        currentViewWindow,
        positionEndpointCalc, positionTestFn, positionStyleFn(148, 186, 101));

      $scope.availRuleIntervalsToDraw = _.where(availRuleIntervals, function(interval) {
        return interval.count > 0;
      });

      $scope.notUnavailRuleIntervalsToDraw = _.where(notUnavailRuleIntervals, function(interval) {
        return interval.count > 0;
      });

      $scope.unavailRuleIntervalsToDraw = _.where(unavailRuleIntervals, function(interval) {
        return interval.count > 0;
      });
    };

    calcAvailabilityRules();
    findAllRuleIntervals();

    });
